import type {FC} from 'react';
import type {ActiveCategory, CategoryItem} from '.';
import {cn} from '../../../../../../../lib/classname';
import {Taxonomies} from '../Taxonomies';

type Props = {
  rootCategories: CategoryItem[];
  activeRootCategory?: ActiveCategory;
  subCategories: CategoryItem[];
  activeSubCategory?: ActiveCategory;
};
export const CategoriesPC: FC<Props> = ({
  rootCategories,
  activeRootCategory,
  subCategories,
  activeSubCategory,
}) => {
  return (
    <div className={cn('flex flex-col gap-y-8')}>
      <Taxonomies
        items={rootCategories}
        activeIndex={activeRootCategory ? activeRootCategory.index : -1}
      />
      {subCategories.length > 0 && (
        <Taxonomies
          items={subCategories}
          activeIndex={activeSubCategory ? activeSubCategory.index : -1}
        />
      )}
    </div>
  );
};
